(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.property-card-fund-header', ['pp.widgets-templates']);

ngModule.component('ppPropertyCardFundHeader', {
    templateUrl: 'widgets/_angular/property-card-fund-header/property-card-fund-header.tpl.html',
    bindings: {
        property: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);